// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PfCof1qH {
  display: flex;
  justify-content: center;
  padding: 2rem;
}

.EvJ2XTG9 {
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.SzQz83mw {
  font-size: 1.5rem;
  color: #4ecca3;
  text-align: center;
}

.O_wihRNv {
  background: #16213e;
  border: 1px solid #2a2a4a;
  border-radius: 12px;
  padding: 1.5rem;
}

.sMR9BPin {
  font-size: 1.1rem;
  color: #e0e0e0;
  margin-bottom: 1rem;
}

.eyZH7U2V {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.GV4oT3h5 {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  color: #b0b0c0;
  font-size: 0.9rem;
}

.IKdYcVQs {
  padding: 0.6rem 0.8rem;
  background: #1a1a2e;
  border: 1px solid #2a2a4a;
  border-radius: 6px;
  color: #e0e0e0;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s;
}

.IKdYcVQs:focus {
  border-color: #4ecca3;
}

.VI19llIl {
  padding: 0.7rem;
  background: #4ecca3;
  color: #1a1a2e;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: 0.3rem;
}

.VI19llIl:hover {
  background: #3db893;
}

.VI19llIl:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.Hi2D9osj {
  color: #ff6b6b;
  font-size: 0.85rem;
  padding: 0.5rem;
  background: rgba(255, 107, 107, 0.1);
  border-radius: 4px;
}

.e5c4bjoP {
  color: #4ecca3;
  font-size: 0.85rem;
  padding: 0.5rem;
  background: rgba(78, 204, 163, 0.1);
  border-radius: 4px;
}

.P6gVXzwI {
  color: #808090;
  font-size: 0.85rem;
}

/* Responsive: 480px phone breakpoint */
@media (max-width: 480px) {
  .PfCof1qH {
    padding: 1rem;
  }

  .EvJ2XTG9 {
    gap: 1rem;
  }

  .O_wihRNv {
    padding: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Profile.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  padding: 2rem;\n}\n\n.content {\n  width: 100%;\n  max-width: 500px;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.title {\n  font-size: 1.5rem;\n  color: #4ecca3;\n  text-align: center;\n}\n\n.section {\n  background: #16213e;\n  border: 1px solid #2a2a4a;\n  border-radius: 12px;\n  padding: 1.5rem;\n}\n\n.sectionTitle {\n  font-size: 1.1rem;\n  color: #e0e0e0;\n  margin-bottom: 1rem;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n}\n\n.label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  color: #b0b0c0;\n  font-size: 0.9rem;\n}\n\n.input {\n  padding: 0.6rem 0.8rem;\n  background: #1a1a2e;\n  border: 1px solid #2a2a4a;\n  border-radius: 6px;\n  color: #e0e0e0;\n  font-size: 1rem;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.input:focus {\n  border-color: #4ecca3;\n}\n\n.button {\n  padding: 0.7rem;\n  background: #4ecca3;\n  color: #1a1a2e;\n  border: none;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n  margin-top: 0.3rem;\n}\n\n.button:hover {\n  background: #3db893;\n}\n\n.button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.error {\n  color: #ff6b6b;\n  font-size: 0.85rem;\n  padding: 0.5rem;\n  background: rgba(255, 107, 107, 0.1);\n  border-radius: 4px;\n}\n\n.success {\n  color: #4ecca3;\n  font-size: 0.85rem;\n  padding: 0.5rem;\n  background: rgba(78, 204, 163, 0.1);\n  border-radius: 4px;\n}\n\n.info {\n  color: #808090;\n  font-size: 0.85rem;\n}\n\n/* Responsive: 480px phone breakpoint */\n@media (max-width: 480px) {\n  .container {\n    padding: 1rem;\n  }\n\n  .content {\n    gap: 1rem;\n  }\n\n  .section {\n    padding: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PfCof1qH`,
	"content": `EvJ2XTG9`,
	"title": `SzQz83mw`,
	"section": `O_wihRNv`,
	"sectionTitle": `sMR9BPin`,
	"form": `eyZH7U2V`,
	"label": `GV4oT3h5`,
	"input": `IKdYcVQs`,
	"button": `VI19llIl`,
	"error": `Hi2D9osj`,
	"success": `e5c4bjoP`,
	"info": `P6gVXzwI`
};
export default ___CSS_LOADER_EXPORT___;
